<template>
    <div class="head-bar">
        <div class="logo-box content">
            <div class="logo" @click="gotoIndex">
                <!-- 根据站点标识显示不同的logo，左右排列 -->
<!--                {{'siteType:'+siteType}}-->
<!--                <img v-if="siteType === 'zhuhai'" class="website-logo" src="/static/img/zhuhai/珠西logo.svg" alt="" @click="gotoIndex">-->
<!--                <img v-if="siteType === 'zhaoqing'" src="@assets/肇庆.png" class="site-logo"/>-->

                <img src="@assets/big_logo.svg" style="width: 268px;"/>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "LoginHeader",
    data() {
        return {
            siteType: '', // 站点标识：用于区分不同的分站
        }
    },
    methods:{
        gotoIndex(){
            this.$router.push({name:'Index', path: '/index'})
        }
    },
    mounted() {
        // 从store中获取站点标识
        this.siteType = this.$store.state.siteType;
    },
}
</script>

<style scoped>
.head-bar{
    width: 100%;
    background: #fff;
    height: 130px;
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
}
.logo{
    cursor: pointer;
}
.site-name{
    font-family: SourceHanSansCN-Medium;
    font-size: 12px;
    color: #2F86C2;
    letter-spacing: 0;
    text-align: justify;
    margin-left: 12px;
}
</style>
